<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="380">
    <v-card v-if="serial" class="elevation-0">
      <v-card-title class="pb-0">
        <span class="text-subtitle-1 font-weight-bold">Preview</span>
        <v-spacer />
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="text-center pt-2 pb-4">
        <div class="preview-frame mx-auto pa-4 mb-4">
          <v-img :src="imageUrl" contain max-height="320" />
        </div>
        <div class="monospace text-body-1">{{ serial }}</div>
      </v-card-text>
      <v-card-actions class="px-6 pb-5">
        <v-btn text rounded class="text-none" @click="$emit('input', false)">Close</v-btn>
        <v-spacer />
        <v-btn color="primary" rounded class="text-none" :href="downloadUrl" target="_blank">
          <v-icon left>mdi-download</v-icon>
          Download PDF
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
var API_URL = process.env.VUE_APP_API_URL || 'http://localhost:8001';

export default {
  name: 'LabelPreview',
  props: {
    value: Boolean,
    serial: String,
    labelSize: { type: String, default: '12mm' },
  },
  computed: {
    imageUrl: function () {
      if (!this.serial) return '';
      return API_URL + '/api/labelbase/label/image/' + this.serial + '?label_size=' + this.labelSize;
    },
    downloadUrl: function () {
      if (!this.serial) return '';
      return API_URL + '/api/labelbase/label/download/' + this.serial + '?label_size=' + this.labelSize + '&download=true';
    },
  },
};
</script>

<style scoped>
.preview-frame {
  background: white;
  border-radius: 12px;
  display: inline-block;
}
.monospace {
  font-family: 'Roboto Mono', monospace;
}
</style>
